import type { trips as tripsEn } from "../en/trips";

export const trips: typeof tripsEn = {
  list: {
    title: "Zájezdy",
    subtitle: "Správa katalogu zájezdů",
    newTrip: "Nový zájezd",
    searchPlaceholder: "Hledat zájezdy…",
    allStatuses: "Všechny stavy",
    loadError: "Zájezdy se nepodařilo načíst. Zkuste to prosím znovu.",
    empty: "Žádné zájezdy nenalezeny",
    duration: "Délka",
    /** Cena uvedená jako „od" — příznak `priceIsFrom` na zájezdu. */
    priceFrom: "od {{price}}",
    days_one: "{{count}} den",
    days_few: "{{count}} dny",
    days_other: "{{count}} dní",
    confirmDelete: "Opravdu chcete smazat „{{title}}“? Tuto akci nelze vrátit zpět.",
    noCoordinates: "Bez souřadnic",
    noCoordinatesHint:
      "Hotel nemá souřadnice, a jeho stránka proto nemá mapu. Doplňte je v záložce Hotel.",
  },
  order: {
    title: "Pořadí zájezdů",
    subtitle: "Jeden ruční žebříček, který určuje výchozí pořadí všude, kde se katalog vypisuje.",
    openFromList: "Pořadí zájezdů",
    ranked: "Žebříček",
    rankedEmpty: "Žebříček je prázdný — zařaďte zájezd ze seznamu vpravo.",
    unranked: "Nezařazené publikované zájezdy",
    unrankedEmpty: "Hledání neodpovídá žádný nezařazený publikovaný zájezd.",
    unrankedHint: "Nezařazený zájezd je běžný stav — vypisuje se pod žebříčkem, od nejnovějšího.",
    searchPlaceholder: "Hledat zájezdy…",
    add: "Zařadit do žebříčku",
    remove: "Odebrat ze žebříčku",
    moveUp: "Posunout nahoru",
    moveDown: "Posunout dolů",
    dragHandle: "Přetažením změníte pořadí",
    position: "{{position}}. místo",
    saving: "Ukládám pořadí…",
    saveError: "Pořadí se nepodařilo uložit. Zkuste to prosím znovu.",
    loadError: "Zájezdy se nepodařilo načíst. Zkuste to prosím znovu.",
    lengthHint:
      "Žebříček má {{total}} zájezdů. Doporučená délka je kolem stovky — delší se špatně udržuje.",
  },
  edit: {
    tabs: {
      basic: "Základní údaje",
      itinerary: "Itinerář",
      experience: "Detaily zážitku",
      hotel: "Hotel",
      included: "Co je v ceně",
      gallery: "Galerie",
      dates: "Termíny",
      components: "Komponenty",
      calculation: "Kalkulace",
      content: "Obsah",
    },
    newTrip: "Nový zájezd",
    editTrip: "Upravit zájezd",
    newSubtitle: "Vytvořte nový zájezd",
    editingSubtitle: "Úprava: {{title}}",
    notFound: "Zájezd nenalezen",
    backToTrips: "Zpět na zájezdy",
    statusDraft: "Koncept",
    statusPublish: "Publikovat",
    statusArchive: "Archivovat",
    hasValidationErrors: "Obsahuje chyby validace",
    unsavedParts: {
      message:
        "Zájezd je založený, ale tyto části se neuložily: {{parts}}. Zadejte je znovu a zájezd uložte.",
      parts: {
        upgrades: "prémiové upgrady",
        dates: "termíny",
        components: "komponenty",
      },
      close: "Zavřít",
    },
  },
  form: {
    sectionBasic: "Základní informace",
    titleRequired: "Název je povinný",
    titlePlaceholder: "např. Vietnam — od severu k jihu",
    slug: "URL slug",
    slugRequired: "Slug je povinný",
    slugPlaceholder: "např. vietnam-od-severu-k-jihu",
    destinationRequired: "Destinace je povinná",
    selectDestination: "Vyberte destinaci",
    destinationTags: "Další destinace",
    destinationTagsSearch: "Hledat destinace...",
    guide: "Průvodce",
    noGuide: "Bez průvodce",
    guideVideo: "Video průvodce (YouTube URL)",
    difficulty: "Náročnost",
    tripKind: "Druh zájezdu",
    tripKindTour: "Zájezd (vícedenní itinerář)",
    tripKindExperience: "Zážitek (krátké highlighty)",
    tripKindHint:
      "Podoba obsahu: zájezdy zobrazují itinerář den po dni, zážitky krátké highlighty.",
    bookingMode: "Režim rezervace",
    bookingModeFixed: "Pevné termíny (výběr z termínů)",
    bookingModeOnRequest: "Na vyžádání (libovolný den v kalendáři)",
    bookingModeHint:
      "Jak zákazníci rezervují: z vypsaných termínů, nebo libovolný den v kalendáři (respektuje dostupné dny v týdnu a předstih). Při konverzi se vytvoří privátní termín.",
    tripType: "Typ zájezdu",
    countries: "Země (ISO-2)",
    tripStyle: "Styl zájezdu",
    styleNotSet: "— Nenastaveno —",
    sectionPricing: "Cena a délka",
    priceFrom: "Cena (Kč)",
    priceIsFrom: "Uvádět jako cenu „od“",
    priceIsFromHint:
      "Web napíše „od 55 000 Kč“ místo pevné částky — u ceny zájezdu i u cen jednotlivých termínů. Pobytové zájezdy mají „od“ vždy. Když se ceny odjezdů liší, naskočí „od“ i bez zaškrtnutí.",
    priceOriginal: "Původní cena (Kč)",
    durationHours: "Délka (hodiny)",
    durationDays: "Délka (dny)",
    groupSize: "Velikost skupiny",
    groupSizePeople: "osob",
    groupMinAtLeast: "Minimum musí být alespoň 1",
    groupMinExceedsMax: "Minimum nesmí být větší než maximum",
    groupMaxAtLeast: "Maximum musí být alespoň 1",
    groupMaxBelowMin: "Maximum nesmí být menší než minimum",
    sectionMeetingPoint: "Výchozí místo srazu",
    meetingPoint: "Místo srazu",
    meetingPointPlaceholder: "např. kancelář v Hanoji, Old Quarter, 12 Hang Bac",
    meetingTime: "Čas",
    heroTitle: "Titulek hero",
    heading: "Nadpis stránky (H1)",
    sectionDescription: "Popis",
    shortDescription: "Krátký popis pro karty a SEO",
    shortDescriptionPlaceholder: "Jednořádkový popis zobrazený na kartách zájezdů",
    fullDescription: "Úplný popis",
    fullDescriptionPlaceholder: "Podrobný popis zájezdu…",
    sectionSeo: "SEO",
    metaTitle: "Meta titulek",
    metaTitlePlaceholder: "SEO titulek (max. 60 znaků)",
    metaDescription: "Meta popis",
    metaDescriptionPlaceholder: "SEO popis (max. 160 znaků)",
    featuredImage: "Hlavní obrázek",
    showAsFeatured: "Zobrazit jako doporučený",
    lastMinuteOffer: "Last minute nabídka",
    forWomen: "Zájezd pro ženy",
    hasCzechGuide: "Má českého průvodce",
    tags: "Štítky",
    region: "Region",
    regionNorth: "Sever",
    regionCentral: "Střed",
    regionSouth: "Jih",
    otherTags: "Ostatní štítky",
    addTagPlaceholder: "Napište štítek a stiskněte Enter",
    contentOverview: "Přehled obsahu",
    statItineraryDays: "Dní v itineráři:",
    statGalleryImages: "Obrázků v galerii:",
    statIncluded: "Položek v ceně:",
    statExcluded: "Položek mimo cenu:",
    statDates: "Termínů:",
    statFaq: "FAQ položek:",
    statReels: "Social reels:",
    statRouteMap: "Mapa trasy:",
    yes: "Ano",
    no: "Ne",
  },
  basic: {
    groupSizeOpenEnded: "Bez horní hranice (podle domluvy)",
    groupSizeOpenEndedNoteOnRequest:
      "Web u zájezdu napíše „od 1 osoby, podle domluvy“. Kapacita soukromého termínu se vezme z počtu cestujících objednávky — z velikosti skupiny se nedopočítá.",
    groupSizeOpenEndedNoteFixed:
      "Web u zájezdu napíše „od 1 osoby, podle domluvy“. Kapacitu každého termínu pak musíte vyplnit ručně v záložce Termíny — z velikosti skupiny se nedopočítá.",
  },
  calculation: {
    saveFirst: "Nejdřív zájezd uložte — kalkulace se váží k existujícímu zájezdu.",
  },
  content: {
    faqTitle: "FAQ",
    faqPrefill: {
      topicGeneral: "Obecné",
      q1: "Jak velké jsou vaše skupiny?",
      a1: "Naše skupiny mají obvykle {{groupMin}}–{{groupMax}} cestovatelů. Komorní počet cestujících zaručuje osobní přístup a autentické zážitky.",
      a1OpenEnded: "Zájezd jede od 1 osoby, podle domluvy.",
      q2: "Nabízíte upgrady?",
      a2: "Ano! Nabízíme prémiové upgrady včetně letenek v business třídě, luxusnějších hotelů a privátních transferů. Podrobnosti vám rádi sdělí naši specialisté.",
      q3: "Jaká je náročnost zájezdu?",
      a3: "Zájezd má náročnost „{{difficulty}}“. Zvládne ho většina cestovatelů s běžnou kondicí.",
      q4: "Je zájezd vhodný pro sólo cestovatele?",
      // a1/a4 musí znít STEJNĚ jako fallback FAQ na webovém detailu zájezdu
      // (`apps/web/src/components/pages/TripDetail.astro`) — obojí končí v DB jako
      // FAQ zájezdu, takže rozejít se nesmí (řez 01, AK11).
      a4: "Rozhodně! Řada našich klientů vyráží na cesty sama a vrací se s novými přáteli. Komorní počet cestujících vytváří přátelské prostředí pro každého.",
    },
    socialReels: "Social reels (Inspirujte se)",
    routeMap: "Mapa trasy",
    guideRecommendation: "Doporučení průvodce",
    guideRecommendationPlaceholder: "Napište osobní doporučení průvodce…",
    similarTrips: "Podobné zájezdy",
    searchTripsPlaceholder: "Hledat zájezdy…",
    relatedPagesTitle: "Související stránky",
    relatedPagesSearch: "Hledat stránky…",
    relatedPagesDraftSuffix: "(koncept)",
    relatedPagesNone: "Zatím neexistuje žádná stránka.",
    relatedPagesManage: "Spravovat stránky",
    relatedPagesNoRight: "Stránky zakládá správce nebo editor.",
    inspirations: {
      title: "Inspirace na trase",
      hint: "Na webu: zájezd se ukáže v sekci ‚Zájezdy, na kterých to zažijete‘ na stránce vybraných inspirací; na stránce zájezdu se vazba nezobrazuje.",
      pickerLabel: "Vybrané inspirace",
      searchPlaceholder: "Hledat inspirace…",
      draftSuffix: "(koncept)",
      blockedNew: "Vazby půjde přidat po prvním uložení.",
      blockedUnpublished: "Inspirace na trase půjde přiřadit po publikování zájezdu.",
      loading: "Načítám vazby…",
    },
    premiumUpgrades: "Prémiové upgrady",
  },
  experience: {
    leadTime: "Předstih rezervace (hodiny)",
    leadTimeHint: "Minimální počet hodin, s jakým musí zákazník zájezd na vyžádání poptat předem",
    availableWeekdays: "Dostupné dny v týdnu",
    availableWeekdaysHint: "Nic nezaškrtnuto = zájezd na vyžádání je dostupný každý den.",
    weekdays: {
      mon: "Po",
      tue: "Út",
      wed: "St",
      thu: "Čt",
      fri: "Pá",
      sat: "So",
      sun: "Ne",
    },
  },
  gallery: {
    title: "Galerie",
    youtubeTitle: "YouTube videa",
    youtubeDescription: "Přidejte URL YouTube videí k tomuto zájezdu",
    youtubeEmpty: "Zatím žádná videa",
    youtubeAdd: "Přidat video",
  },
  highlights: {
    title: "Highlighty",
    hint: "Marketingové lákadla — proč si tento zážitek rezervovat.",
    add: "Přidat highlight",
    titlePlaceholder: "Název (např. Vaření s místní rodinou)",
    descriptionPlaceholder: "Krátký popis (volitelné)",
    remove: "Odebrat highlight",
    empty: "Zatím žádné highlighty — přidejte alespoň jeden, ať zážitek zaujme.",
  },
  hotel: {
    needsOnRequest:
      "Zájezd je v režimu „Pevné termíny“. Hotelová prezentace (stránka hotelu a výpis hotelů) se aktivuje až po přepnutí režimu rezervace na „Na vyžádání“ — tam si zákazník volí vlastní termín pobytu.",
    stars: "Počet hvězdiček",
    starsNotSet: "— Nenastaveno —",
    starsOption_one: "{{count}} hvězdička",
    starsOption_few: "{{count}} hvězdičky",
    starsOption_other: "{{count}} hvězdiček",
    surchargeUnit: "za pobyt",
    meals: {
      title: "Stravování",
      hint: "Zaškrtněte, co hotel nabízí, a doplňte příplatek za celý pobyt (0 = v ceně).",
    },
    departures: {
      title: "Odletová místa",
      hint: "Odkud může zákazník letět. Pokud hotel prodáváte jen bez letenek, nechte vše nezaškrtnuté.",
      anyNote: "Zákazník má vždy k dispozici i volbu „Nerozhoduje“ — ta se zde neadministruje.",
    },
    features: {
      title: "Zaměření hotelu",
      hint: "Zaškrtněte vše, co o hotelu platí. Podle toho si zákazník filtruje pobytové zájezdy na webu.",
    },
    location: {
      title: "Poloha na mapě",
      label: "Souřadnice hotelu",
      placeholder: "-8.79203, 115.22704",
      hint: "Na Mapy.cz nebo v Mapách Google klikněte pravým tlačítkem na hotel, zkopírujte souřadnice a vložte je sem. Pole bere oba tvary: se znaménkem (-8.79203, 115.22704) i se světovými stranami (8.79203S, 115.22704E). Souřadnice se ukážou na mapě na stránce hotelu a jako vlastní bod hotelu na mapě zájezdů. Když pole necháte prázdné, stránka hotelu mapu mít nebude a mapa zájezdů ukáže hotel jen v bodě jeho destinace.",
    },
    rooms: {
      title: "Pokoje",
      hint: "Katalog pokojů, ze kterého si zákazník vybírá v poptávce. Pořadí změníte přetažením.",
      add: "Přidat pokoj",
      namePlaceholder: "Název pokoje (např. Deluxe s výhledem na moře)",
      occupancyPlaceholder: "Obsazení (např. 2 dospělí a 2 děti)",
      bedsPlaceholder: "Postele (např. king size)",
      sizePlaceholder: "Velikost (m²)",
      descriptionPlaceholder: "Krátký popis zobrazený na kartě pokoje…",
      surcharge: "Příplatek (za pobyt)",
      surchargeHint: "0 znamená, že je pokoj „v ceně“.",
      remove: "Odebrat pokoj",
      empty: "Zatím žádné pokoje — hotel bez pokojů je platný stav, poptávka jen žádné nenabídne.",
    },
  },
  included: {
    orderHint:
      "Pořadí je pevné: nejdřív letenky, pak ubytování, pak ostatní. Položky pište v tomhle pořadí — web je vypíše tak, jak jsou.",
    includesTitle: "Cena zahrnuje ({{n}})",
    excludesTitle: "Cena nezahrnuje ({{n}})",
    includedPlaceholder: "např. Zpáteční letenky",
    excludedPlaceholder: "např. Vstupní vízum",
    noItems: "Zatím žádné položky",
    optionalActivities: "Volitelné aktivity",
    addActivity: "Přidat aktivitu",
    noActivities: "Žádné volitelné aktivity.",
    activityNamePlaceholder: "Let horkovzdušným balónem",
    activityPricePlaceholder: "cca 90 USD, platba na místě",
    activityDescriptionPlaceholder: "Let při východu slunce nad Vang Vieng (dle počasí)",
    notePlaceholder: "např. Ceny jsou za osobu ve dvoulůžkovém pokoji…",
  },
  itinerary: {
    title_one: "Itinerář ({{count}} den)",
    title_few: "Itinerář ({{count}} dny)",
    title_other: "Itinerář ({{count}} dní)",
    addDay: "Přidat den",
    empty: "V itineráři zatím nejsou žádné dny",
    addFirstDay: "Přidat první den",
    dayTitle: "Den {{day}}",
    dayTitlePlaceholder: "Den {{day}}: Název",
    spanDays: "Kolik dnů položka pokrývá",
    spanDaysHint:
      "Víc než 1 u programu psaného v rozsazích („1.–2. den: přelet“). Následující dny se přečíslují samy.",
    descriptionPlaceholder: "Podrobný popis dne…",
    accommodation: "Ubytování",
    accommodationPlaceholder: "např. 4* hotel v centru",
    meals: "Strava",
    mealBreakfast: "Snídaně",
    mealLunch: "Oběd",
    mealDinner: "Večeře",
    highlightsLabel: "Highlighty (oddělené čárkou)",
    highlightsPlaceholder: "např. Návštěva chrámu, Tradiční oběd",
    guideTip: "Tip průvodce (volitelné)",
    guideTipPlaceholder: "Osobní tip průvodce k tomuto dni…",
  },
  schedule: {
    title: "Harmonogram",
    hint: "Hodinová osa toho, co zákazník zažije.",
    addStep: "Přidat krok",
    titlePlaceholder: "Název (např. Vyzvednutí v hotelu)",
    descriptionPlaceholder: "Popis (volitelné)",
    removeStep: "Odebrat krok",
    empty: "Zatím žádné kroky harmonogramu.",
  },
  tips: {
    title: "Cestovní tipy ({{n}})",
    add: "Přidat tip",
    empty: "Zatím žádné cestovní tipy",
    addFirst: "Přidat první tip",
    newTip: "Nový tip…",
    category: "Kategorie",
    titlePlaceholder: "např. Co si sbalit",
    content: "Obsah",
    contentPlaceholder: "Podrobný popis tipu…",
    categories: {
      general: "Obecné",
      packing: "Balení",
      health: "Zdraví",
      money: "Peníze",
      culture: "Kultura",
      safety: "Bezpečnost",
    },
  },
  componentsEditor: {
    title: "Komponenty / kusovník ({{n}})",
    info: "Tyto naceněné komponenty automaticky vytvářejí <strong>koncepty rezervací u dodavatelů</strong> při vytvoření objednávky (<em>Na objednávku</em> — násobí se počtem osob) nebo přidání termínu (<em>Na termín</em> — jedna sdílená rezervace). Je to šablona: její změna se nikdy nedotkne rezervací už existujících objednávek.",
    empty: "Zatím žádné komponenty — přidejte, z čeho se zájezd skládá.",
    seed: "Založit",
    qty: "Ks",
    removeComponent: "Odebrat komponentu",
    allAdded: "Všechny komponenty katalogu jsou přidané",
    addComponent: "Přidat komponentu…",
  },
  dates: {
    title: "Termíny ({{n}})",
    addDate: "Přidat termín",
    empty: "Zatím žádné termíny",
    addFirstDate: "Přidat první termín",
    occupancyTitle: "Odvozeno z obsazenosti vůči kapacitě",
    days_one: "{{count}} den",
    days_few: "{{count}} dny",
    days_other: "{{count}} dní",
    spots: "{{left}}/{{capacity}} míst",
    velin: "Velín",
    openVelin: "Otevřít velín termínu",
    private: "Soukromý",
    privateHint:
      "Soukromý termín vznikl z objednávky zájezdu na vyžádání. Web ho nenabízí a uložení zájezdu ho nesmaže.",
    departureDate: "Datum odjezdu",
    returnDate: "Datum návratu",
    priceAmount: "Cena (Kč)",
    capacity: "Kapacita",
    capacityRequired:
      "Vyplňte kapacitu — zájezd nemá horní hranici skupiny, ze které by se dopočítala.",
    booked: "Obsazeno",
    lifecycle: "Stav termínu",
    guideAssignedElsewhere: "Přiřazuje se v harmonogramu / velínu termínu.",
    internalNotes: "Poznámky (interní)",
    internalNotesPlaceholder: "Interní poznámky k tomuto termínu…",
    spotsLeftWarning_one: "Zbývá jen {{count}} místo!",
    spotsLeftWarning_few: "Zbývají jen {{count}} místa!",
    spotsLeftWarning_other: "Zbývá jen {{count}} míst!",
  },
};
